module.exports = __webpack_public_path__ + "static/auditbanner-091202b08faeec73e2158d130076668e.jpg";